import http from "./storageManager/methods/http";
import { RADIUS } from "./common/constants";
import { getConfig } from "./config/localizerConfig";

const localizationServiceProxy = {
  config: getConfig(),
  async getStoreFromSSS(storeId) {
    const validStoreId = Number(storeId);
    if (!validStoreId) {
      throw new Error("Valid Store ID is required");
    }
    const params = new URLSearchParams({
      storeid: validStoreId,
      type: "json",
    });
    const storeSearchServiceUrl = `${this.config.host}${
      this.config.storeSearchService
    }?${params.toString()}`;
    const fallbackUrl = `${this.config.canonicalHost}${
      this.config.storeSearchService
    }?${params.toString()}`;
    return await http.getWithJsonPFallback({ url: storeSearchServiceUrl, fallbackUrl });
  },
  async getLocalStore(coordinates) {
    const params = new URLSearchParams({
      show: "metadata,localstore",
    });

    if (coordinates) {
      if (Number(coordinates.latitude)) {
        params.append("latitude", coordinates.latitude);
      }
      if (Number(coordinates.longitude)) {
        params.append("longitude", coordinates.longitude);
      }
      if (Number(coordinates.accuracy)) {
        params.append("accuracy", coordinates.accuracy);
      }
    }
    const localizationServiceUrl = `${this.config.localizationApiHost}${
      this.config.service
    }.jsonp?${params.toString()}`;
    return await http.get({ url: localizationServiceUrl, useJsonP: true });
  },
  async getMetadata() {
    const params = new URLSearchParams({
      show: "metadata",
    });

    const localizationServiceUrl = `${this.config.localizationApiHost}${
      this.config.service
    }.jsonp?${params.toString()}`;
    return await http.get({ url: localizationServiceUrl, useJsonP: true });
  },
  async getNearestStoreByRadius(coordinates) {
    const { latitude, longitude } = coordinates || {};
    if (!Number(latitude) || !Number(longitude)) {
      return;
    }

    const params = new URLSearchParams({
      latitude,
      longitude,
      pagesize: 20,
      radius: RADIUS.IN_STORE_MILE_RADIUS,
      type: "json",
    });

    const storeSearchServiceUrl = `${this.config.host}${
      this.config.storeSearchService
    }?${params.toString()}`;
    const fallbackUrl = `${this.config.canonicalHost}${
      this.config.storeSearchService
    }?${params.toString()}`;

    return await http.getWithJsonPFallback({ url: storeSearchServiceUrl, fallbackUrl });
  },
  async getStoreNearby({ pagesize, radius, timeout, zipcode }) {
    const params = new URLSearchParams({
      radius,
      zipcode,
      type: "json",
    });

    if (pagesize && Number(pagesize) > 0) {
      params.append("pagesize", pagesize);
    }

    const storeSearchServiceUrl = `${this.config.host}${
      this.config.storeSearchService
    }?${params.toString()}`;
    const fallbackUrl = `${this.config.canonicalHost}${
      this.config.storeSearchService
    }?${params.toString()}`;

    return await http.getWithJsonPFallback({ url: storeSearchServiceUrl, fallbackUrl, timeout });
  },
  async getZipCodeData(zipcode) {
    const params = new URLSearchParams({
      type: "json",
      zipcode,
    });
    const locationServiceURL = `${this.config.host}${
      this.config.locationService
    }?${params.toString()}`;
    const fallbackUrl = `${this.config.canonicalHost}${
      this.config.locationService
    }?${params.toString()}`;

    return await http.getWithJsonPFallback({ url: locationServiceURL, fallbackUrl });
  },
};

export default localizationServiceProxy;